import { Award } from "@/types/Customizations";

/**
 * Validates if an award has all required data for display
 * @param award - The award object to validate
 * @returns boolean indicating if the award is valid
 */
export const validAwards = (awards: Award[]): Award[] => {
  if (!awards || awards.length === 0) {
    return [];
  }

  return awards.filter((award) => {
    const englishImage = award.englishImage?.[0];
    const spanishImage = award.spanishImage?.[0];

    return (
      englishImage?.fileUrl &&
      spanishImage?.fileUrl &&
      award.englishAltText &&
      award.spanishAltText
    );
  });
};

/**
 * Checks if there are any valid awards in the array
 * @param awards - The awards array to check
 * @returns boolean indicating if there are valid awards
 */
export const hasValidAwards = (awards: Award[]): boolean => {
  return validAwards(awards).length > 0;
};
